const GlobalActionTypes = {
  SET_CURRENT_PATH: 'SET_CURRENT_PATH',
  TOGGLE_SIDEBAR_HIDDEN: 'TOGGLE_SIDEBAR_HIDDEN',
  SELECT_CUSTOMER_INFORMATION: 'SELECT_CUSTOMER_INFORMATION',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED',
  SET_USER: 'SET_USER',
  LOGOUT: 'LOGOUT'
};

export default GlobalActionTypes;
